export const style = (theme) => {
    return {
        progressContainer: {
            background: 'transparent',
            border: 'none',
            boxShadow: 'unset',
        },
    };
};
